import './hero.scss';
import { useTranslation } from 'react-i18next';
import { SlideAnimation } from '../components/shared/slide-animation';
import { Dispatch, SetStateAction } from 'react';

import bg from '../assets/background/bg-hero.jpg';
import { motion } from 'framer-motion';

const Hero = ({
  setInquiryPopup,
  setBrochurePopup,
}: {
  setInquiryPopup: Dispatch<SetStateAction<boolean>>;
  setBrochurePopup: Dispatch<SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation();
  return (
    <div className="Hero">
      <div className="background" style={{ backgroundImage: `url(${bg})` }}></div>
      <div className="user-controller">
        <div className="small-title">{t('hero.text-0')}</div>
        <div className="big-title">
          {t('hero.text-1')} <div className="circle"></div>
        </div>
        <div className="button-box">
          <motion.a
            rel="noreferrer"
            onClick={() => {
              setInquiryPopup(true);
            }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <button className="link-button">{t('hero.btn-0')}</button>
          </motion.a>

          <motion.a
            rel="noreferrer"
            onClick={() => {
              setBrochurePopup(true);
            }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <button className="link-button">{t('hero.btn-1')}</button>
          </motion.a>
        </div>
      </div>
    </div>
  );
};

export default Hero;
